// Copies the SEO head of a server-rendered page state (title, description, robots, canonical, prev/next, hreflang
// alternates, Open Graph and Twitter tags) into the current document after an in-page navigation, so the head
// describes the URL the history now shows instead of the one first loaded. Only the tags the Metadata and
// OpenGraphTags components render (marked data-ts-head) are replaced; head tags a shop adds itself stay.
const headTagSelector = '[data-ts-head]';

export function syncPageHead(serverDom: Document): void {
    if (!serverDom) {
        return;
    }

    const title = serverDom.querySelector('title');
    if (!title) {
        // The response carries no head components: keep the current head untouched.
        return;
    }
    document.title = title.textContent;

    const incoming = [...serverDom.querySelectorAll(headTagSelector)];
    const current = [...document.head.querySelectorAll(headTagSelector)];

    const anchor = current.length > 0 ? current[0] : null;
    incoming.forEach(element => {
        const clone = document.importNode(element, true);
        if (anchor) {
            document.head.insertBefore(clone, anchor);
        } else {
            document.head.appendChild(clone);
        }
    });
    current.forEach(element => element.remove());
}
